import React, { CSSProperties } from 'react';

interface NewLoaderProps {
  style?: CSSProperties;
}

const NewLoader: React.FC<NewLoaderProps> = ({ style }) => {
  return <img alt="" src="/new-loader.svg" style={style} />;
};

export default NewLoader;
